import { useQuery } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

import { authQueryOptions } from "@/lib/core/auth";

import {
    configureViewStatePublisher,
    getKitsViewStateAvailable,
    publishKitsViewState,
    republishViewState,
    useKitsViewStateSync,
} from "@/features/kits-conversations";

export function KitsViewStateHost() {
    useKitsViewStateSync();

    const appUserId = useQuery(authQueryOptions()).data?.appUserId;

    const { data: available = false } = useQuery({
        queryKey: ["kits-view-state-available", appUserId],
        queryFn: getKitsViewStateAvailable,
        staleTime: Number.POSITIVE_INFINITY,
    });
    useSyncExternalStore(
        () => {
            configureViewStatePublisher(
                available
                    ? (state) => publishKitsViewState({ data: { state } })
                    : null,
            );
            if (available) republishViewState();
            return () => configureViewStatePublisher(null);
        },
        () => available,
        () => false,
    );

    return null;
}
